<template>
  <div>
    <!-- Email Input -->
    <div class="col form-group" style="margin-bottom: 44px">
      <input
        id="email"
        v-model="obj.email"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        class="w-100"
        tabindex="1"
        :placeholder="$t('email.placeholder')"
      />
    </div>

    <!-- Confirm Email Input -->
    <div class="col form-group">
      <input
        id="emailConfirmation"
        v-model="obj.emailConfirmation"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        class="w-100"
        :placeholder="$t('email.confirmPlaceholder')"
        tabindex="2"
        @keyup.enter="validateFields"
        @paste="blockPaste"
      />
    </div>
  </div>
</template>

<script>
/* State */
import { mapState, mapMutations } from 'vuex'
import { loginFB } from '../../services/ServFB.js'
import { translateApiMessage } from '@/i18n/translateApiMessage'

const lFB = new loginFB()

export default {
  name: 'Email',
  props: {
    validate: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
    toastMessage: '',
  }),
  computed: {
    ...mapState(['config', 'registrationObject', 'subdomain', 'template']),
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  mounted() {
    // Create a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))

    document.getElementById('email').focus()
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),
    /* Helpers */
    blockPaste() {
      return false
    },
    translateMessage(text) {
      return translateApiMessage(text, this.$i18n)
    },
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: this.$t('common.attention'),
        variant: variant,
        solid: true,
      })
    },
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      if (!this.checkEmail(this.obj.email)) {
        const warningMsg = this.$t('email.invalid')
        this.addRegistrationError({
          msg: warningMsg,
        })
        this.toastMessage = warningMsg
        this.makeToast('warning')

        hasErrors = true
      }

      if (this.obj.email !== this.obj.emailConfirmation) {
        const warningMsg = this.$t('email.mismatch')
        this.addRegistrationError({
          msg: warningMsg,
        })
        this.toastMessage = warningMsg
        this.makeToast('warning')

        hasErrors = true
      }

      if (!hasErrors) {
        this.checkExistingEmail(this.obj.cpf || null, this.obj.email)
      }
    },
    checkEmail(email) {
      const emailRegex = /\S+@\S+\.\S+/
      return emailRegex.test(email)
    },
    async checkExistingEmail(cpf, email) {
      try {
        const response = await lFB.checkUserEmail(
          this.config.name,
          cpf,
          email,
          this.config.systemID,
          this.config.ownerId,
        )
        if (response.header.codigo !== 1) {
          this.toastMessage = this.translateMessage(
            response.header.msg || this.$t('email.unknownVerificationError'),
          )
          this.makeToast('warning')
          return
        }
        this.$store.commit('updateRegistrationObject', this.obj)
        this.$emit('next')
      } catch (err) {
        const message = this.translateMessage(String(err))
        this.addRegistrationError({
          msg: message,
        })
        this.toastMessage = message
        this.makeToast('warning')
      }
    },
  },
}
</script>
